"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Moises = exports.FirebaseApp = void 0;
const upload_1 = require("./modules/upload");
const auth_1 = require("./modules/auth");
Object.defineProperty(exports, "FirebaseApp", { enumerable: true, get: function () { return auth_1.FirebaseApp; } });
const graphql_1 = require("./modules/graphql");
const task_1 = require("./modules/task");
class Moises {
    constructor(config) {
        this.config = config;
        this.session = {};
        this.upload = new upload_1.MoisesUpload(this.config, this.session);
        this.auth = new auth_1.MoisesAuth(this.config, this.session);
        this.task = new task_1.MoisesTask(this.config, this.session);
        this.graphQL = new graphql_1.MoisesGraphQL(this.config, this.session);
    }
}
exports.Moises = Moises;
